export default function RequestServiceConstantsMixin(constants){
  constants.defineRequestConstants = () => {
    constants('REQUEST', 'SUCCESS', 'FAILURE')
  }
  return constants
}